import { Controller } from "@hotwired/stimulus"
import "whatwg-fetch"
import axios from "axios"
import { initPullToRefresh } from "../../pullToRefresh"

export default class extends Controller {
  static targets = ["button"]

  async handleClick(event) {
    event.preventDefault()
    event.currentTarget.querySelector(".round-player").style.display = "none"
    if (this.hasButtonTarget) {
      for (const button of this.buttonTargets) {
        button.disabled = true
      }
    }

    const form = event.currentTarget.closest("form")
    const formData = new FormData(form)
    const method = formData.get("_method") || form.method

    try {
      const response = await axios.request({
        url: form.action,
        method,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      document.getElementById("layout-body").innerHTML = response.data
      initPullToRefresh()
    } catch (error) {
      console.error(error)
    }
  }
}
